import { useState } from "react";
import CampaignPageHeader from "containers/admin/clients/campaign/components/campaign-page-header/campaign-page-header";
import CreativeTable from "containers/admin/clients/campaign/campaign-creative-page/components/creactive-table/creative-table";
import CampaignContextMenu from "containers/admin/clients/campaign/campaign-creative-page/components/campaign-context-menu/campaign-context-menu";
import { FillHeightPage } from "ui/data-grid";

import { usePermissionBlacklist } from "hooks/use-permission-blacklist";

import { Permission } from "types/auth";

import { useTouchpoints } from "hooks/api/use-touchpoints";
import { TouchpointActionProvider } from "../../contexts/touchpoint-action-context";
import { useCampaignJobPollingContext } from "hooks/campaign-job-polling-provider";

const CampaignCreativePageContent = () => {
  usePermissionBlacklist([Permission.PERM_CLIENT_USER]);

  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  const { data } = useTouchpoints({});

  const { startPolling } = useCampaignJobPollingContext();

  const handleSuccess = () => {
    setSelectedIds([]);
    startPolling();
  };

  const selectedTouchpoints = (data?.items ?? []).filter((item) => selectedIds.includes(item.id));
  const totalCreatives = data?.totalElements ?? 0;

  const contextMenu = (
    <CampaignContextMenu
      totalCreatives={totalCreatives}
      selectedTouchpoints={selectedTouchpoints}
    />
  );

  return (
    <TouchpointActionProvider onSuccess={handleSuccess}>
      <FillHeightPage>
        <CampaignPageHeader />

        <CreativeTable
          selectedIds={selectedIds}
          setSelectedIds={setSelectedIds}
          actionSlot={contextMenu}
        />
      </FillHeightPage>
    </TouchpointActionProvider>
  );
};

export default CampaignCreativePageContent;
